import { TooltipLexique } from 'locales/types/components/tooltip';

export const tooltipLexique: TooltipLexique = {
    instagram_stories: 'Instagram stories',
    noResult: 'No result',
};

export default tooltipLexique;
